import { Component, OnInit, ViewChild, EventEmitter, AfterViewInit, HostListener } from '@angular/core';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { EmployeesRest } from '../employee.rest';
import { Employee } from '../employee.model';
import { EmployeeModalComponent } from '../employee-modal/employee-modal.component'
import { GridSelection, SelectionMode, GridMainFilter, SortedColumn } from '../../../core/shared/grid/grid.model';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { SpinnerService } from '../../../core/services/spinner-handler/spinner-handler.service';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { DialogControl } from '../../../core/shared/dialog/dialog.model';
import { GridParamsRestoringService } from '../../../core/services/grid-params-restoring/grid-params-restoring.service';
import { GridParamsRestorable } from '../../../core/services/grid-params-restoring/grid-params-restoring.model';
import { PrintoutService } from '../../../core/services/printout/printout-service.service';
import { MenuButton } from '../../../core/shared/tabmenu/tabmenu.model';
import { TimesheetPrintoutConfigModalComponent } from './timesheet-printout-config-modal/timesheet-printout-config-modal.component';
import { LoginRest } from '../../../login/login.rest';

@Component({
  selector: 'app-employees-list',
  templateUrl: './employees-list.component.html',
  styleUrls: ['./employees-list.component.scss']
})
export class EmployeesListComponent extends GridSelection implements GridParamsRestorable, OnInit, HasPermissions, DialogControl, AfterViewInit {
  public dialogConfigData: any;
  public onDialogClose: EventEmitter<any> = new EventEmitter<any>();
  public confirmDialog() { };
  public closeDialog() { };
  isConfirmButtonDisabled: boolean = false;

  public showInactive: boolean;
  permissions: Permissions;

  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(TimesheetPrintoutConfigModalComponent) printoutConfigModal: TimesheetPrintoutConfigModalComponent;
  //@ViewChild(EmployeeModalComponent) employeeModal: EmployeeModalComponent;
  private path: string;
  public employees: Employee[];
  public editedItemId: number = undefined;

  private isFromExternalIssues = false;


  private isEditable: boolean;
  private isRemovable: boolean;
  private isAdd: boolean;
  private canGeneratePrintout: boolean = false;

  private hideToggles: boolean;
  private expanded: boolean;

  private headers = [
    { displayName: 'Pracownik', propertyName: 'fullName', propertyType: 'string' },
    { displayName: 'Email', propertyName: 'email', propertyType: 'string' },
    { displayName: 'Telefon', propertyName: 'phone', propertyType: 'string' },
    { displayName: 'Kod', propertyName: 'code', propertyType: 'string' },
    { displayName: 'Aktywny', propertyName: 'isActive', propertyType: 'bool' }
  ];

  private gridMenuButtons: MenuButton[] = [
    { text: 'Generuj listy obecności', class: 'btn-info', icon: '', onClick: () => { this.generateTimesheetsForEmployees(); }, enabled: false, isForSelected: true }
  ];

  selectedCustomer: any;
  mainFilter: GridMainFilter[];
  customerRows: ObjectToSelect[];
  private isRestoredMainFilter: boolean = false;
  public initialFilters: any;
  public initialPageNumber: number = 0;
  public initialPageSize: number;
  public initialSortedColumn: SortedColumn;
  public previousMainFilters: any;
  public detailsPath: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private employeesRest: EmployeesRest,
    private permissionService: PermissionsService,
    private spinnerService: SpinnerService,
    private gridParamsRestoringService: GridParamsRestoringService,
    private loginRest: LoginRest
  ) {
    super();
    this.onResize();
  }

  @HostListener('window:resize', ['$event'])
  private onResize(event?) {
    if (window.innerWidth <= 769) {
      this.hideToggles = true;
      this.expanded = false;
    } else {
      this.hideToggles = false;
      this.expanded = true;
    }
  }

  ngOnInit() {
    this.spinnerService.show();
    this.mainFilter = new Array();
    this.processDialogConfig();
    if (this.isFromExternalIssues) {
      this.path = 'api/issueexternal/employees/grid';
      var claimType = 'IssueExt';
    } else {
      this.path = 'api/employees/grid';
      var claimType = 'Employee';
      this.getCustomerRows();
    }

    this.selectionMode = this.selectionMode === SelectionMode.none ? SelectionMode.none : this.selectionMode;

    this.setPermissions(claimType);

    this.loginRest.GetLoggedUser().subscribe(user => {
      if (user.role === 'Administratorzy') {
        this.canGeneratePrintout = true;

        this.gridMenuButtons.find(x => x.text === 'Generuj listy obecności').enabled = true;
        this.selectionMode = SelectionMode.multi;
      }
    });

    this.isEditable = !this.dialogConfigData && this.permissions.canShow;//this.selectionMode === SelectionMode.none && this.permissions.canShow;
    this.isRemovable = !this.dialogConfigData && this.permissions.canDelete;//this.selectionMode === SelectionMode.none && this.permissions.canDelete;
    this.isAdd = !this.dialogConfigData && this.permissions.canAdd;//this.selectionMode === SelectionMode.none && this.permissions.canAdd;

    if (!this.dialogConfigData) {
      this.isRestoredMainFilter = this.tryRestoreFiltersAndPage();
    }
  }

  ngAfterViewInit() {
    this._grid = this.grid;
    this.grid.mainFilter = this.mainFilter;
    this.spinnerService.hide();
  }

  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  private processDialogConfig() {
    if (!this.dialogConfigData) {
      return;
    }
    if (this.dialogConfigData['isFromExternalIssues']) {
      this.isFromExternalIssues = this.dialogConfigData['isFromExternalIssues'];
    }
    if (this.dialogConfigData['customerId']) {
      this.selectedCustomer = this.dialogConfigData['customerId'];
      let customerCode = this.dialogConfigData['customerCode'];
      let objectToSelect = new ObjectToSelect();
      objectToSelect.id = this.selectedCustomer;
      objectToSelect.name = customerCode;
      this.customerRows = new Array();
      this.customerRows.push(objectToSelect);
      this.mainFilter.push({ internalName: 'CustomerId', value: this.selectedCustomer.toString() });
    }
  }

  private addEmployee() {
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid);
    this.router.navigate(['../employees/employee', 'new'], { queryParams: { employeeId: 0 }, relativeTo: this.route });
  }

  private onRowEdit(row: Employee) {
    this.gridParamsRestoringService.saveCurrentGridParams(this.grid, row.id);
    this.router.navigate(['../employees/employee', row.fullName !== " " ? row.fullName : row.code], { queryParams: { employeeId: row.id }, relativeTo: this.route });
  }

  private onRowDelete(row: Employee) {
    let buttons = {
      yes: { text: "Tak", value: "yes" },
      no: { text: "Nie", value: "no" }
    }

    let message = `Czy na pewno usunąć pracownika ${row.name} ${row.surname}`;
    sweetAlert(message, {
      buttons: buttons
    }).then((value) => {
      switch (value) {
        case "yes":
          const action = this.employeesRest.removeEmployee;
          action.call(this.employeesRest, row.id).subscribe((result: string) => {
            if (result) {
              sweetAlert({ text: `Usunięto pracownika` });
              this.grid.refreshData(false);
            }
          });
          break;
      }
    });
  }

  public onSuccessOperation(value) {
    if (value.isSuccess) {
      sweetAlert({ text: value.isNew ? `Dodano pracownika.` : `Zapisano pracownika.` });
      this.editedItemId = value.employee.id;
    }
    this.grid.refreshData(false);
  }

  public filter() {
    this.clearFilter('CustomerId');
    if (this.selectedCustomer) {
      this.setFilter('CustomerId', this.selectedCustomer.toString());
    }

    this.clearFilter('ShowInactive');
    if (this.showInactive) {
      this.setFilter('ShowInactive', this.showInactive.toString());
    }

    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  private clearFilter(internalName: string) {
    this.mainFilter.forEach((item, index) => {
      if (item.internalName === internalName) { this.mainFilter.splice(index, 1); }
    });
  }

  public clearFilters() {
    this.selectedCustomer = undefined;
    this.clearFilter('CustomerId');

    this.showInactive = undefined;
    this.clearFilter('ShowInactive');

    this.grid.mainFilter = this.mainFilter;
    this.grid.refreshData();
  }

  private setFilter(internalName: string, filterValue: string) {
    if (this.mainFilter != null) {
      this.mainFilter.forEach((item, index) => {
        if (item.internalName === internalName) { this.mainFilter.splice(index, 1); }
      });

      if (filterValue !== undefined) {
        this.mainFilter.push({ internalName: internalName, value: filterValue });
      }

      this.grid.mainFilter = this.mainFilter;
    }
  }

  private getCustomerRows() {
    const action = this.employeesRest.getCustomerRows;

    action.call(this.employeesRest).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.customerRows = result;
      }
    });
  }

  private setFiltersFromRestoredData() {
    const selectedCustomer = this.findFilter('CustomerId');
    this.selectedCustomer = selectedCustomer != null ? parseInt(selectedCustomer) : null;

    const showInactive = this.findFilter('ShowInactive');
    if (showInactive != null && showInactive === 'true') {
      this.showInactive = true;
    } else if (showInactive != null && showInactive === 'false') {
      this.showInactive = false;
    } else {
      this.showInactive = this.showInactive;
    }
  }

  private findFilter(internalName: string): string {
    return this.grid.mainFilter.find(x => x.internalName === internalName) && this.grid.mainFilter.find(x => x.internalName === internalName).value || null;
  }

  private tryRestoreFiltersAndPage(): boolean {
    let previousGridParams = this.gridParamsRestoringService.getPreviousGridParams("employees", false);
    if (!previousGridParams) {
      return false;
    }
    // console.log('previousGridParams:', previousGridParams);

    this.initialFilters = previousGridParams.initialFilters;
    this.initialSortedColumn = previousGridParams.sortedColumn;
    this.initialPageNumber = previousGridParams.initialPageNumber;
    this.initialPageSize = previousGridParams.initialPageSize;
    this.editedItemId = previousGridParams.editedItemId;
    this.previousMainFilters = previousGridParams.previousMainFilters;

    return true;
  }

  private generateTimesheetsForEmployees() {
    var selectedItems = this.grid.getSelectedItems();
    var employeeIds = selectedItems.map(employee => employee.id as number);
    this.printoutConfigModal.setModel(employeeIds);
  }

}
